import { render } from "./VartaContact.vue?vue&type=template&id=ebd5f16e&scoped=true"
import script from "./VartaContact.vue?vue&type=script&lang=js"
export * from "./VartaContact.vue?vue&type=script&lang=js"

import "./VartaContact.vue?vue&type=style&index=0&id=ebd5f16e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd5f16e"]])

export default __exports__